import axios from "axios";
import get from "lodash/get";
import api from "@/api";

const state = {
  token: localStorage.getItem("rmc_token"),
  expressToken: localStorage.getItem("rmc_express_token"),
  user: {},
  userProjects: []
};

const getters = {
  user(state) {
    return state.user;
  },
  noUser(state) {
    return Object.keys(state.user).length === 0;
  },
  token(state) {
    return state.token;
  },
  expressToken(state) {
    return state.expressToken;
  },
  administeredOrganizations(state) {
    return get(state, "user.administrator_of_organizations", []);
  },
  administeredOrganizationId(state) {
    return get(state, "user.administrator_of_organizations[0].id");
  },
  isOrgManager(state) {
    return get(state, "user.roles", []).includes(
      "ROLE_ORGANIZATION_MANAGER"
    );
  },
  isStaff(state) {
    return get(state, "user.roles", []).includes(
      "ROLE_STAFF"
    );
  },
  userProjects(state) {
    return state.userProjects;
  }
};

const actions = {
  async sessionLogin({ commit }, { token, expressToken }) {
    localStorage.setItem("rmc_express_token", expressToken);
    localStorage.setItem("rmc_token", token);
    commit("LOGIN", { token, expressToken });
  },
  async login({ commit }, { username, password }) {
    const formData = new FormData();
    formData.append("username", username);
    formData.append("password", password);

    const { data:token, headers } = await axios.post(`${process.env.VUE_APP_API_URL}/user/getapikey`, formData)
    const expressToken = headers['express-token'];

    localStorage.setItem("rmc_express_token", expressToken);
    localStorage.setItem("rmc_token", token);
    commit("LOGIN", { token, expressToken });
  },
  logout({
    commit
  }) {
    localStorage.removeItem("rmc_token");
    localStorage.removeItem("rmc_express_token");
    commit("LOGOUT");
  },
  async fetchUser({
    commit
  }) {
    const v2 = api();
    const {
      data
    } = await v2.get("/rmc/user");
    commit("USER_DETAILS", data);
  },
  async fetchUserProjects({
    commit
  }) {
    const current = api();
    const {
      data
    } = await current.get("/rmc/user/projects");
    commit("USER_PROJECTS", data.projects);
  }
};

const mutations = {
  LOGIN(state, { token, expressToken }) {
    state.token = token;
    state.expressToken = expressToken;
  },
  LOGOUT(state) {
    state.token = null;
    state.expressToken = null;
  },
  USER_DETAILS(state, user) {
    state.user = user;
  },
  USER_PROJECTS(state, userProjects) {
    state.userProjects = userProjects;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};